module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	var _ = {
		getTranslation: function (alias) {
		  var translation = {
			addCountry: fox.i18n.getTranslation('addCountry', 'Add your Country'),
			addCountryOfResidence: fox.i18n.getTranslation('addCountryOfResidence', 'Add your Country of residence'),
			addCountryOfBirth: fox.i18n.getTranslation('addCountryOfBirth', 'Add your Сountry of birth'),
		  };
	
		  return translation[alias] || '';
		},
	};

	fox.registerWidget('SitePage_Profile_Search_Country', {
		
		_collection: [],
		_fullCollection: [],

		_topPosition: 0,

		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				useCountryId: false,
				emptyPlaceholder: '',
				'widgets.getCountryApi': {
					widget: 'Api',
					method: 'ProfileInfo.getCountry'
				},
				'handleWom.getCountryApiHandler': {
					widget: '#getCountryApi',
					event: 'success',
					callback: fox.bind(function(data) {
						this.setCollection(data.answer.response.success);
					}, this)
				},
				'handleDom.focusSearch': {
					target: '[name="country"]',
					event: 'focus',
					callback: 'focusedField'
				},
				'handleDom.blurSearch': {
					target: '[name="country"]',
					event: 'blur',
					callback: 'restoreField'
				},
				'handleDom.keyupSearch': {
					target: '[name="country"]',
					event: 'keyup',
					callback: 'keyupEvt'
				}
			});

			this.callParent('configure', arguments);
		},

		keyupEvt: function(elem, foxEvent, w, e) {
			var code = e.which;
			var val = elem.value;

			var $searchList = this.searchList;
			var $itemElems = fox.dom.select('.item-search-profile', this.searchList);
			var countElems = $itemElems.length;
			
			var firstElem = $itemElems[0];
			var lastElem = $itemElems[$itemElems.length - 1];
			var activeElem = fox.dom.select('.item-search-profile.active')[0];

			switch (code) {
				
				case 38:
					if (firstElem && (activeElem !== firstElem)) {
						var countryBlock = fox.dom.select('.countries-list')[0];
						var countryBlockTop = countryBlock.getBoundingClientRect().top;
						var activeElemTop = activeElem.getBoundingClientRect().top;

						if ((countElems > 7) && (activeElemTop < countryBlockTop + 2)) {
							countryBlock.scrollTop -= activeElem.previousSibling.clientHeight;
						}

						fox.dom.removeClass('active', activeElem);
						activeElem = activeElem.previousSibling;
						fox.dom.addClass('active', activeElem);
					}
					break;

				case 40:
					if (firstElem && (activeElem !== lastElem)) {
						var countryBlock = fox.dom.select('.countries-list')[0];
						var countryBlockBottom = countryBlock.getBoundingClientRect().bottom;
						var activeElemBottom = activeElem.getBoundingClientRect().bottom;

						if ((countElems > 7) && (activeElemBottom >= countryBlockBottom - 1)) {
							countryBlock.scrollTop += activeElem.clientHeight;
						}
						
						fox.dom.removeClass('active', activeElem);
						activeElem = activeElem.nextSibling;
						fox.dom.addClass('active', activeElem);
					}
					break;
				
				case 10:
				case 13:
					this.setValue(this.useCountryId ? fox.dom.wrap(activeElem).attr('data-country-id') : activeElem.innerText);
					break;
				
				default:
					if (this.timerId) {
						clearTimeout(this.timerId);
					}
					this.search(val);
			}
		},

		focusedField: function(el, alias, w, e) {
			if (e) {
				e.preventDefault();
				e.cancelBubble = true;
			}
			
			if (el) {
				fox.dom.removeClass('empty', el.parentNode);
			}

			var placeholder = fox.dom.selectFirst('#placeholder-country', this.element);
			var list;

			if (placeholder) {
				fox.dom.addClass('focused', placeholder.parentNode);
			}

			if (fox.dom.select('.item-search-profile', this.element).length) {
				fox.dom.addClass('opened', this.searchList.parentNode.parentNode);
			}
		},

		restoreField: function(el, alias, w, e) {
			e.preventDefault();
			e.cancelBubble = true;

			window.setTimeout(fox.bind(function () {
				fox.dom.removeClass('opened', this.searchList.parentNode.parentNode);
			}, this), 500);

			var placeholder = fox.dom.selectFirst('#placeholder-country', this.element);

			if (placeholder) {
				fox.dom.removeClass('focused', placeholder.parentNode);
				placeholder.innerText = this.getValue();
			}

			if (!el.value) {
				fox.dom.addClass('empty', el.parentNode);
				if (placeholder) {
					placeholder.innerHTML =  fox.i18n.getTranslation('addCountry', 'Add your Country');
				}

				if (this.getOption('dispatchEventIfFieldGetEmpty')) {
					this.setValue('');
				}
			} else {
				this.setValue(placeholder ? placeholder.innerText : el.value);
			}
		},

		init: function() {
			this.country = '';
			this.defaultsLoaded = false;

			this.useCountryId = this.getOption('useCountryId');
			
			this.form = this.getParent();
			
			this.handleEvent(this, 'changed', 'render');
			this.handleEvent(this.form, 'defaultValuesLoaded', 'start');

			return this.callParent('init', arguments);
		},

		running: function() {
			this.rwom1('#getCountryApi').send({}, false);

			var profileSubmit = fox.wom.selectFirst('~#profileSubmit');

			this.handleEvent(this, 'addedToDom', fox.bind(function() {
				if (!fox.isEmpty(profileSubmit._data)) {
					var data = profileSubmit._data;
					this.postRender(data);
				}
			}, this));
		},

		postRender: function(data) {
			
			var getBlock = function(tagName, placeHolder) {
				var block = '';
				switch (tagName) {
					// case 'a':
					// case 'div':
					// 	block = placeHolder.parentNode.parentNode.parentNode;
					// break;
					case 'span':
						block = placeHolder.parentNode.parentNode.parentNode;
					break;
				}
				return block;
			};

			switch (data.approveState) {
				// submit
				case 1:
				// approved
				case 2:
					var placeHolder = fox.dom.selectFirst('#placeholder-country', this.element);

					if (typeof placeHolder !== 'undefined') {
						placeHolder.contentEditable = false;

						var tagName = placeHolder.tagName.toLowerCase(),
							block = getBlock(tagName, placeHolder);

						if (typeof block !== 'undefined') {
							var formElm = fox.dom.selectFirst('[name="country"]', block);

							if (typeof formElm !== 'undefined' && fox.inArray(['select', 'input'], formElm.tagName.toLowerCase())) {
								formElm.disabled = true;
							}
							fox.dom.addClass('locked', block);
						}
					}
				break;
				// return
				case 3:
					var placeHolder = fox.dom.selectFirst('#placeholder-country', this.element);

					if (typeof placeHolder !== 'undefined') {
						var tagName = placeHolder.tagName.toLowerCase(),
							block = getBlock(tagName, placeHolder);

						if (typeof block !== 'undefined') {
							var icon = fox.dom.selectFirst('.warning-icon', block);

							if (data.submitStatus.country === 1) {
								var formElm = fox.dom.selectFirst('[name="country"]', block);

								if (typeof formElm !== 'undefined' && fox.inArray(['select', 'input'], formElm.tagName.toLowerCase())) {
									formElm.disabled = true;
								}
								fox.dom.removeClass('warning-error', block);
								icon.style.display = 'none';

								placeHolder.contentEditable = false;
								fox.dom.addClass('locked', block);

							} else {
								fox.dom.addClass('warning-error', block);
								icon.style.display = 'block';
							}
						}
					}
				break;
			}
		},

		start: function() {
			if (!this.defaultsLoaded) {
				if(this.form._defaults['country']) {
					this.country = fox.clone(this.form._defaults['country']);
				}
				this.render();
				this.defaultsLoaded = true;
			}
		},

		rendering: function() {
			var emptyPlaceholder = this.getOption('emptyPlaceholder');
			var data = {
				currentValue: this.country
				? this.country
				: emptyPlaceholder !== ''
				? _.getTranslation(emptyPlaceholder)
				: _.getTranslation('addCountry'),
			  current: this.country ? 1 : 0,
	  
			};

			if (this.useCountryId && this.country) {

				var item = this._collection.filter(function (item) {
					if (item.id === this.country) {
						return true;
					}

					return false;
				}.bind(this));

				if (item && item.length) {
					data.currentValue = item[0].name;
				}
			}

			this.fragment = this.createFragment();
			if (fox._isNewfe) {
				this.fragmentData = this.getTemplater().setData([data]).compile();
			} else {
				this.fragmentData = fox.Zen(this.getOption('template'), [data]);
			}
			
			this.fragment.appendChild(this.fragmentData);

			this.searchList = fox.dom.selectFirst('#search-list', this.fragment);
			this.formElement = fox.dom.selectFirst('[name="country"]', this.fragment);
		},

		setCollection: function(collection) {
			this._collection = collection;
			this._fullCollection = collection; 
		},

		inCollection: function(term) {
			for (var skey in this._collection) {
				if (this._collection[skey]['name'] === term) {
					return true;
				}
			}
			return false;
		},

		inCollectionId: function(term) {
			for (var skey in this._collection) {
				if (this._collection[skey]['id'] === term) {
					return true;
				}
			}
			return false;
		},

		search: function(term) {
			var searchResultStack = [],
				searchResultFirstStack = [],
				searchResultFullStack = [],
				searchResultPartStack = [],

				rgxpFirst = new RegExp('^' + term + '$', 'i'),
				rgxpFull = new RegExp('^' + term + '.*', 'i'),
				rgxpPart = new RegExp('^.*' + term + '.*', 'i')
			;

			for (var skey in this._collection) {
				var elem = this._collection[skey]['name'];
				
				if (rgxpFirst.test(elem)) {
					searchResultFirstStack.push(skey);
				} else if (rgxpFull.test(elem)) {
					searchResultFullStack.push(skey);
				} else if(rgxpPart.test(elem)) {
					searchResultPartStack.push(skey);
				}
			}
			searchResultStack = searchResultStack.concat(searchResultFirstStack, searchResultFullStack, searchResultPartStack);
			
			this.focusedField();

			this.searchList = fox.dom.selectFirst('#search-list', this.element);
			this.searchList.innerHTML = '';

			if (searchResultStack.length > 0) {
				var containerFragment = document.createDocumentFragment(),
					blockSearchList = fox.dom.selectFirst('.search-list', this.element);

				fox.dom.addClass('mb-list-dropdown', this.element);
				blockSearchList.style.visibility = 'visible';

				for (var i = 0; i < searchResultStack.length; i++) {
					var rowFragment;

					if (fox._isNewfe) {
						rowFragment = this.getTemplater('sitepage_profile_searchbox_item')
							.setData([this._collection[searchResultStack[i]]])
							.compile();
					} else {
						rowFragment = fox.Zen('sitepage_profile_searchbox_item', [this._collection[searchResultStack[i]]]);
					}
					containerFragment.appendChild(rowFragment);
				}

				this.searchList.appendChild(containerFragment);

				var itemElems = fox.dom.select('.item-search-profile', this.searchList);
								
				fox.each(itemElems, function(elem, index){

					if (index === 0) {
						fox.dom.addClass('active', elem);
					}

					fox.dom.on(fox.utils.isTouchDevice() ? 'touchstart' : 'mousedown', elem, fox.bind(function(e) {
						this.formElement.value = this.useCountryId ? fox.dom.wrap(elem).attr('data-country-id') : elem.innerText;
						this.setValue(this.useCountryId ? fox.dom.wrap(elem).attr('data-country-id') : elem.innerText);

					}, this));

				}, this);
			}
		},

		setValue: function(value, skipEvent) {
			skipEvent = fox.isEmpty(skipEvent) ? false : skipEvent;
			this.country = value;
			if (fox.oop.instanceOf(this.form, 'DomForm')) {
				this.form.setValue(this.getAlias(), this.country, true);
			} else {
				this.form._setValue(this.getAlias(), this.country);
			}
			
			if (!skipEvent) {
				this.dispatchEvent('changed', this.country);
			} else {
				this.render();
			}
		},

		getValue: function() {
			return this.country;
		},

		includeCollection: function(include) {
			var collection = [];
			for (var skey in this._fullCollection) {
				if (include.indexOf(this._fullCollection[skey]['name']) !== -1) {
					collection.push(this._fullCollection[skey]);
				}
			}
			this._collection = collection;
			return this;
		},

		excludeCollection: function(exclude) {
			var collection = this._fullCollection.slice(0);
			for (var skey in this._collection) {
				if (exclude.indexOf(this._collection[skey]['name']) !== -1) {
					collection.splice(skey,1);
				}
			}
			this._collection = collection;
			return this;
		},

		restoreCollection: function() {
			return this._collection = this._fullCollection;
		},

		disable: function (argument) {
			this.formElement.disabled = true;
			this.isDisabled = true;
			this.dispatchEvent('disabled', this);
		},

		enable: function (argument) {
			this.formElement.disabled = false;
			this.isDisabled = false;
			this.dispatchEvent('enabled', this);
		}

	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/profile/search/country.js
// module id = 353
// module chunks = 2